import { format, isToday, isYesterday } from 'date-fns';

/**
 * Formats a Date object to a YYYY-MM-DD string in local time.
 * This avoids the day-shifting issue caused by toISOString() which uses UTC.
 */
export function formatToLocalDate(date: Date | null | undefined): string | null {
  if (!date) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function formatContextualDateTime(
  value: string | Date | null | undefined,
  fallback = ''
): string {
  if (!value) return fallback;

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return typeof value === 'string' ? value : fallback;
  }

  if (isToday(date)) {
    return `Today, ${format(date, 'h:mm a')}`;
  }
  if (isYesterday(date)) {
    return `Yesterday, ${format(date, 'h:mm a')}`;
  }
  if (date.getFullYear() === new Date().getFullYear()) {
    return format(date, 'MMM d, h:mm a');
  }
  return format(date, 'MMM d, yyyy, h:mm a');
}
